import { Component, Input } from '@angular/core';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { GebaeudeGehoertZuSdrComponent } from '../../../../shared/components/gebaeude-gehoert-zu-sdr/gebaeude-gehoert-zu-sdr.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DecimalHochkommaPipe } from '../../../../shared/pipes/simple/decimalHochkomma.pipe';
import { YesNoPipe } from '../../../../shared/pipes/simple/yes-no.pipe';
import { GebaeudeMasterDetailEntryMeta, GebaeudeVersionDetailEntryMeta } from '../../../../core/av-api';
import { environment } from '../../../../../environments/environment';
import { GebaeudeArtStringPipe } from '../../../../shared/pipes/simple/gebaeude-art-string.pipe';
import { keysToTranslate } from '../../../../../i18n/keys-to-translate';
import { GwrLinkComponent } from '../../../../shared/components/gwr-link/gwr-link.component';

@Component({
  selector: 'cap-gebaeude-kopfdaten',
  templateUrl: './gebaeude-kopfdaten.component.html',
  styleUrls: ['./gebaeude-kopfdaten.component.scss'],
  imports: [
    KopfdatenelementComponent,
    NgbTooltip,
    GebaeudeGehoertZuSdrComponent,
    KompaktTimepointComponent,
    TranslatePipe,
    DecimalHochkommaPipe,
    YesNoPipe,
    GwrLinkComponent
  ]
})
export class GebaeudeKopfdatenComponent {
  _version: GebaeudeVersionDetailEntryMeta;

  gebaeudeArtString: string;

  externerGwrLink: string = environment.gwrServerUrl + '?egid=';
  hasExternalGwr: boolean = environment.gwrServerUrl !== null;

  @Input()
  gebaeude: GebaeudeMasterDetailEntryMeta;

  constructor(private gebaeudeArtStringPipe: GebaeudeArtStringPipe) {
    keysToTranslate<string>([
      'gebaeudeart',
      'Gebaeudeflaeche',
      'gebaeude.BE-GID',
      'gebauede.gehoertZuSDR',
      'Versicherungsnummer',
      'Einzelobjekt'
    ]);
  }

  @Input()
  set version(value: GebaeudeVersionDetailEntryMeta) {
    if (!value) {
      return;
    }
    this._version = value;
    this.gebaeudeArtString = this.gebaeudeArtStringPipe.transform(this._version.gebaeudeArten);
  }

  openExternalGWRLink(egid: string) {
    if (this.hasExternalGwr) {
      window.open(this.externerGwrLink + egid, '_blank');
    }
  }
}
